
import {
    REQUEST_INSTITUTE,
    RESPONSE_INSTITUTE,
    FAILURE_INSTITUTE,
    REQUEST_INSTITUTE_WITH_FILTER,
    AFF_SORT_UPDATE
} from '../../actions/types';

const initialState = {
    keyword: '',
    isFetching: false,
    results: [],
    sortItem: { value: "CITATION", label: "Citation" },
    error: false,
    isInitalScreen: true,
    totalAffiliations: 0,
    totalArticles: 0,
    statusCode: 0,
    country: [],
    year: 'All',
    isFilterActive: false
};

const setFetching = (state, action) => {
    return {
        ...state,
        isFetching: true,
        results: [],
        keyword: action.payload.keyword,
        isInitalScreen: false,
        totalAffiliations: 0,
        totalArticles: 0,
        statusCode: 0,
        country: [],
        year: 'All',
        isFilterActive: false
    }
}

const setFailure = (state, action) => {
    return {
        ...state,
        isFetching: false,
        error: true,
        results: [],
        totalAffiliations: 0,
        totalArticles: 0,
    }
}

const setResults = (state, action) => {

    let results = action.payload.results || [];
    let totalArticles = action.payload.totalArticles || 0;
    let totalAffiliations = action.payload.totalAffiliations || 0;
    let statusCode = action.payload.statusCode;

    return {
        ...state,
        isFetching: false,
        error: false,
        results,
        totalArticles,
        totalAffiliations,
        statusCode
    }

}


const setFetchingFilter = (state, action) => {
    return {
        ...state,
        isFetching: true,
        isFilterActive: true,
        country: action.payload.country,
        year: action.payload.year
    }
}

const updateInstitute = (state, action) => {

    let sortItem = action.payload.results || [];

  return {
    ...state,
    sortItem
  };

}


export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_INSTITUTE:
            return setFetching(state, action);
            break;

        case RESPONSE_INSTITUTE:
            return setResults(state, action);

        case FAILURE_INSTITUTE:
            return setFailure(state, action);

        case REQUEST_INSTITUTE_WITH_FILTER:
            return setFetchingFilter(state, action);

        case AFF_SORT_UPDATE:
            return updateInstitute(state, action);

        default:
            return state;
            break;
    }
}